import React, { useState, useEffect } from 'react';
import ReviewSection from './ReviewSection';

const scores = [
  { num:'4.8', label:'Quality', w:'96%' },
  { num:'4.7', label:'Schedule', w:'94%' },
  { num:'4.6', label:'Cost', w:'92%' },
  { num:'4.8', label:'Willing to Refer', w:'96%' },
];
const mentions = ['Professional (6)','Communicative (4)','Timely (4)','Great Project Management (3)','High-Quality Work (3)','Exceeds Expectations (2)'];

export default function ClutchSection() {
  return (
    <ReviewSection id="clutch" dark>
      <div className="rs-label-row reveal-fade">
        <span className="rs-num">02</span>
        <span className="rs-platform-label">[ CLUTCH REVIEWS ]</span>
        <span className="rs-score">4.8 / 5.0</span>
      </div>
      <div className="rs-giant-wrap">
        <div className="rs-giant reveal-clip" aria-hidden="true">CLUTCH</div>
        <div className="rs-giant-meta reveal-fade">
          <div className="rs-stars-big" style={{color:'#D93025'}}>★★★★★</div>
          <div className="rs-count">
            25 B2B Verified Reviews &nbsp;·&nbsp;{' '}
            <a href="https://clutch.co/profile/koderspedia-solutions" target="_blank" rel="noopener noreferrer" style={{color:'#FF6B47',fontSize:12,textDecoration:'none',borderBottom:'1px solid rgba(217,48,37,.4)'}}>View on Clutch ↗</a>
          </div>
        </div>
        <h2 className="rs-heading reveal-fade">KodersPedia Reviews on Clutch</h2>
        <p className="rs-subheading reveal-fade">Verified B2B client feedback on quality, communication and delivery</p>
      </div>

      <div className="rs-featured reveal-up">
        <h3 className="rs-h3">Clutch Client Rating Breakdown</h3>
        <div className="cl-score-grid">
          {scores.map(s => (
            <div key={s.label} className="cl-score-item">
              <div className="cl-score-num">{s.num}</div>
              <div className="cl-score-bar-track"><div className="cl-score-bar" style={{width:s.w}} /></div>
              <div className="cl-score-label">{s.label}</div>
            </div>
          ))}
        </div>
        <h3 className="rs-h3">What Clients Value About KodersPedia</h3>
        <div className="cl-mentions">
          {mentions.map(m => <span key={m} className="cl-mention">✦ {m}</span>)}
        </div>
      </div>

      {/* Slider: .rs-list remains the slider wrapper; items use className "rs-item" */}
      <div className="rs-list" style={{position:'relative'}}>
        {(() => {
          const reviews = [
            {
              initials: 'VC',
              stars: '★★★★★ 5.0',
              quote: "Koderspedia's team is highly communicative, ensuring clients are kept informed throughout the project. Their proactive communication truly sets them apart.",
              avBg: 'linear-gradient(135deg,#D93025,#FF6B47)',
              name: 'Verified Clutch Client',
              role: 'Small Business — USA · Web Development',
              tags: ['Communicative','Professional']
            },
            {
              initials: 'VC',
              stars: '★★★★★ 5.0',
              quote: 'Responsive, professional, and dedicated. Competitive pricing from $1,000 to $25,000 — excellent value for the quality of work delivered.',
              avBg: 'linear-gradient(135deg,#2563EB,#1E40AF)',
              name: 'Verified Clutch Client',
              role: 'Midmarket — USA · Mobile App Development',
              tags: ['High-Quality Work','Timely']
            },
              {
              initials: 'OS',
              stars: '★★★★★ 5.0',
              quote: "Koderspedia Solutions successfully delivered a full list of necessary app features and the app prototype within the agreed timeline. The team met the client's requirements and communicated effectively through weekly calls and Figma. Their professionalism and high-quality work impressed the client.",
              avBg: 'linear-gradient(135deg,#D93025,#FF6B47)',
              name: 'Oliver Schacht',
              role: 'Hamburg — Germany · Mobile App Development',
              tags: ['Professional','Impressive']
            },
             {
              initials: 'VC',
              quote: "Koderspedia has delivered the project within budget, meeting the client's expectations. They communicate regularly and deliver what they say they will, ensuring a transparent and seamless workflow. Their excellent follow-through, professionalism, and adherence to the established budget stand out.",
              avBg: 'linear-gradient(135deg,#2563EB,#1E40AF)',
              name: 'Verified Clutch Client',
              role: 'Hartford — Connecticut · Web Development',
              tags: ['Budget-Friendly','Seamless Workflow']
            },
            {
              initials: 'VS',
              quote: "In just one week, Koderspedia successfully delivered the website, meeting all the requirements. The client was satisfied with their outstanding project management process and service. The team was friendly, available, and responsive, and they were willing to provide support as needed.",
              avBg: 'linear-gradient(135deg,#D93025,#FF6B47)',
              name: 'Vanessa Soto',
              role: 'Real Estate · Web Development',
              tags: ['Well-Managed','Active Support']
            },
            {
              initials: 'GL',
              quote: "Koderspedia Solutions successfully delivered the project on time. The team responded to needs with kindness and patience and communicated primarily through emails and messaging apps. Their problem-solving abilities impressed the client, resulting in a positive engagement.",
              avBg: 'linear-gradient(135deg,#2563EB,#1E40AF)',
              name: 'Geralda Lushaj',
              role: 'Cliffside Park — New Jersey · Web Development',
              tags: ['Problem-Solving','Positive Engagement']
            }
          ];

          const [perView, setPerView] = useState(2);

          useEffect(() => {
            const updatePerView = () => {
              setPerView(window.innerWidth <= 767 ? 1 : 2);
            };

            updatePerView(); // initial check

            window.addEventListener('resize', updatePerView);

            return () => window.removeEventListener('resize', updatePerView);
          }, []);
          const [index, setIndex] = useState(0);
          const maxIndex = Math.max(0, reviews.length - perView);


          useEffect(() => {
            if (index > maxIndex) setIndex(maxIndex);
          }, [index, maxIndex]);

          return (
            <div style={{maxWidth:'100%',overflow:'hidden'}}>
              <div
                className="rs-list-track"
                style={{display:'flex',transition:'transform 320ms ease',transform:`translateX(-${index * (100 / perView)}%)`}}
              >
                {reviews.map((r, i) => (
                  <div key={i} className="rs-item reveal-up" style={{flex:'0 0 50%',boxSizing:'border-box',paddingRight:16}}>
                    <div className="rs-stars-sm" style={{color:'#D93025',marginBottom:10}}>{r.stars}</div>
                    <div className="rs-quote">{r.quote}</div>
                    <div className="rs-item-left" style={{marginTop:16}}>
                      <div className="rs-av" style={{background:r.avBg}}>{r.initials}</div>
                      <div><div className="rs-name">{r.name}</div><div className="rs-role">{r.role}</div></div>
                    </div>
                    <div className="rs-tags" style={{marginTop:12}}>{r.tags.map(t => <span key={t} className="rs-tag">{t}</span>)}</div>
                  </div>
                ))}
              </div>

              {/* Nav buttons */}
              {maxIndex > 0 && (
                <>
                  <button
                    aria-label="Previous"
                    onClick={() => setIndex(prev => Math.max(0, prev - 1))}
                    style={{position:'absolute',left:"-40px",top:'50%',transform:'translateY(-50%)',zIndex:3,background:'#ce2f30',color:'#fff',border:0,borderRadius:20,width:36,height:36,cursor:'pointer'}}
                  >‹</button>
                  <button
                    aria-label="Next"
                    onClick={() => setIndex(prev => Math.min(maxIndex, prev + 1))}
                    style={{position:'absolute',right:"-40px",top:'50%',transform:'translateY(-50%)',zIndex:3,background:'#ce2f30',color:'#fff',border:0,borderRadius:20,width:36,height:36,cursor:'pointer'}}
                  >›</button>
                </>
              )}
            </div>
          );
        })()}
      </div>

      <div className="rs-stats-strip reveal-fade">
        {[{n:'25',l:'Verified Reviews'},{n:'4.8',l:'Overall Rating'},{n:'$25-49',l:'Hourly Rate'},{n:'2020',l:'Founded'}].map((s,i,arr) => (
          <span key={s.l} style={{display:'contents'}}>
            <div className="rss"><div className="rss-n">{s.n}</div><div className="rss-l">{s.l}</div></div>
            {i < arr.length-1 && <div className="rss-line" />}
          </span>
        ))}
      </div>

      <div style={{maxWidth:1300,margin:'40px auto 0',textAlign:'center'}}>
        <a href="https://clutch.co/profile/koderspedia-solutions" target="_blank" rel="noopener noreferrer" style={{display:'inline-flex',alignItems:'center',gap:8,background:'rgba(217,48,37,.1)',border:'1px solid rgba(217,48,37,.3)',color:'#FF6B47',fontSize:13,fontWeight:600,padding:'12px 28px',borderRadius:100,textDecoration:'none',letterSpacing:'.03em'}}>
          Read All 25 Reviews on Clutch →
        </a>
      </div>
    </ReviewSection>
  );
}
